import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Lock, Mail, AlertCircle } from "lucide-react";
import Picture from "../components/Picture";
import logoWebp from "../assets/tamari-logo.webp";
import logoPng from "../assets/tamari-logo.png";

function formatErr(detail) {
  if (!detail) return "Diçka shkoi keq. Provo përsëri.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || "Gabim në hyrje");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-zinc-200 p-8 sm:p-10">
        <div className="flex flex-col items-center mb-8">
          <Picture webpSrc={logoWebp} fallbackSrc={logoPng} alt="Tamari" loading="eager" className="h-14 w-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#0A0A0A]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            Paneli i Administrimit
          </h1>
          <p className="text-sm text-zinc-500 mt-1">Hyr për të menaxhuar përmbajtjen</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-[#0A0A0A] mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
              <input
                data-testid="admin-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full pl-10 pr-4 py-3 border border-zinc-300 focus:border-[#0A0A0A] focus:ring-1 focus:ring-[#0A0A0A] focus:outline-none"
                placeholder="admin@tamari.al"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-[#0A0A0A] mb-2">Fjalëkalimi</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
              <input
                data-testid="admin-login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full pl-10 pr-4 py-3 border border-zinc-300 focus:border-[#0A0A0A] focus:ring-1 focus:ring-[#0A0A0A] focus:outline-none"
              />
            </div>
          </div>

          {err && (
            <div className="flex items-start gap-2 text-sm text-red-600 bg-red-50 border border-red-200 p-3" data-testid="admin-login-error">
              <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>{err}</span>
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#0A0A0A] text-white py-3 font-medium hover:bg-zinc-800 transition-colors disabled:opacity-50"
          >
            {loading ? "Duke u kyçur..." : "Hyr"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
